import { EventEmitterFactory } from 'pf-frontend-common/src/module/event/emitter.factory';
import { ModalService } from 'pf-frontend-common/src/service/modal/service';

import { configGetSettings } from 'common/helper/config/get-settings';
import { LeadSignInViewStore } from 'common/module/lead/sign-in/view-store';
import { StatsGtmProviderService } from 'common/service/stats-gtm-provider/service';
import { UserPopupService } from 'common/service/user-popup/service';
import { LeadPhoneService } from 'mobile/service/lead-phone/service';

export function LeadSignInViewStoreFactory(): LeadSignInViewStore {
  return new LeadSignInViewStore(
    EventEmitterFactory(),
    UserPopupService(),
    StatsGtmProviderService(),
    ModalService(),
    configGetSettings(),
    LeadPhoneService()
  );
}
